<form class="subdivision-industry-selection-component" [formGroup]="formGroup">
  <mat-form-field>
    <mat-label>Industry class</mat-label>
    <mat-select [formControl]="formControl" placeholder="Industry class..." [compareWith]="compareWithFn">
      @for (subdivisionIndustry of subdivisionIndustries; track subdivisionIndustry) {
        <mat-option [value]="subdivisionIndustry">
          {{subdivisionIndustry.title}}
        </mat-option>
      }
    </mat-select>
    @for (errorKey of errorKeys(formControl); track errorKey) {
      <mat-error>
        @if (formControl.touched && formControl.hasError(errorKey)) {
          {{errorMessage(formControl, errorKey)}}
        }
      </mat-error>
    }
  </mat-form-field>
</form>
